import { useTeamMembers } from '@/hooks/useTeamMembers'
import useUserPermissions from '@/hooks/useUserPermissions'
import { ArrowRight } from '@mynaui/icons-react'
import { Link, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import FacePile from './FacePile'
import { Checkbox, Stack, Text } from './custom-components'
import { Loader } from './custom-components/Loader'
import { Button } from './shadcn/button'
import { Progress } from './shadcn/progress'

const TeamsWelcomeSection = () => {
  const navigate = useNavigate()
  const { userTeams, isFetchingUserTeams } = useUserPermissions()
  const { teamMembers } = useTeamMembers()
  useEffect(() => {
    if (userTeams && userTeams.length < 1) {
      navigate({ to: '/feeds/templates' })
    }
  }, [userTeams])
  return isFetchingUserTeams ? (
    <div className="w-full h-full flex justify-center items-center p-20">
      {' '}
      <Loader />
    </div>
  ) : userTeams && userTeams.length > 0 ? (
    <div className="flex gap-5">
      <div className="border border-themeinput px-6 py-8 rounded-md flex w-full gap-5 items-center">
        <div className="flex flex-col gap-4 w-full">
          <Stack className="px-4 gap-4 items-start">
            <Text weight={'medium'} size={'xxl'} className="w-full">
              {' '}
              You've joined{' '}
              <span className="'w-full bg-newCreativeOSGradient inline-block text-transparent  bg-clip-text">
                {userTeams[0].name}!
              </span>
            </Text>
            <Text weight={'normal'} size={'sm'} className="max-w-[106.364rem] text-slate-600">
              Glad to have you on board. Jump into your workspace and
              <br /> start collaborating with your team!
            </Text>
            {teamMembers && (teamMembers ?? []).length > 0 ? (
              <FacePile
                faces={teamMembers.map((member) => ({ imageUrl: member.avatar, id: member.id }))}
                numFaces={3}
                circleSize={24}
                offset={0.4}
              />
            ) : null}
          </Stack>

          <Button variant="ghost" className="text-themedestructive w-fit">
            View Team Workspace <ArrowRight />{' '}
          </Button>
        </div>
        <img
          src="/welcome_image.png"
          className="w-[12rem] min-w-[12rem] max-w-[12rem] h-[12rem] min-h-[12rem] max-h-[12rem] opacity-15"
        />
      </div>
      <div className="border border-themeinput px-6 py-6 rounded-md flex flex-col w-full gap-5 items-center max-w-[358px]">
        <Text weight={'medium'} size={'lg'} className="text-center">
          Get Started
        </Text>
        <Progress value={30} className="w-full h-1" />{' '}
        <div className="flex items-center gap-3 w-full">
          <Checkbox className="bg-themedestructive" checked={true} />
          <Text weight={'medium'} size={'sm'} className="text-start">
            Joined your team!
          </Text>
        </div>
        <div className="flex items-center gap-3 w-full">
          <ArrowRight />
          <Link to={`/feeds/inspiration`}>
            <Text
              weight={'normal'}
              size={'sm'}
              className="text-start underline hover:no-underline hover:cursor-pointer"
            >
              Discover Inspiration!
            </Text>
          </Link>
        </div>
        <div className="flex items-center gap-3 w-full">
          <ArrowRight />
          <Link to={`/feeds/templates`} search={{ welcomePage: false }}>
            <Text
              weight={'normal'}
              size={'sm'}
              className="text-start underline hover:no-underline hover:cursor-pointer"
            >
              Find Templates
            </Text>
          </Link>
        </div>
      </div>
    </div>
  ) : (
    <div>You have no teams</div>
  )
}

export default TeamsWelcomeSection
